import { usePage } from "@inertiajs/react"
import { StaffManageUserForm } from "@/components/features/staff/manage-users/user-form"
import { StaffLayout } from "@/components/layouts/staff-layout"
import { t } from "@/lib/i18n"
type RoleOption = {
    value: string
    label: string
}
type FormUser = {
    id?: number
    userId?: number
    name?: string
    emailAddress?: string
    role?: string
}
export default function StaffLocationManageUsersNew() {
    const { roleOptions, user } = usePage<{
        roleOptions: RoleOption[]
        user?: FormUser
    }>().props
    return (<StaffLayout>
      <StaffManageUserForm mode="create" title={t("ui.react.pages.staff.location.manage.users.new.new_bill_staff")} description={t("ui.react.pages.staff.location.manage.users.new.create_access_staff_location_current")} roleOptions={roleOptions} user={user}/>
    </StaffLayout>)
}
